export default {
  props: {
    isProduction: {
      default: false
    }
  },
  methods: {
    $mixinsOpenUpdateConfirm() {
      if(this.isProduction && this.status.status.name === 'Approved') {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirm`,
          text: 'You are editing a live RM in nimble. If you save this now the RM status will be ' +
            'changed to pending approval and cant be used in production. Proceed?',
          accept: this.onClickUpdate,
        })
      } else {
        this.onClickUpdate()
      }
    },
  }
}
